import { FC, ReactNode } from 'react';
import {
    Box,
    DialogTitle as MUIDialogTitle,
    DialogTitleProps as MuiDialogTitleProps,
    IconButton,
} from '@mui/material';
import Iconify from '../components/Iconify';

interface DialogTitleProps extends MuiDialogTitleProps {
    onClose: () => void;
    backButton?: ReactNode;
    titleAlign?: 'left' | 'center' | 'right';
    closeIcon?: ReactNode;
    closeButtonDisabled?: boolean;
}

const DialogTitle: FC<DialogTitleProps> = ({
    onClose,
    children,
    sx,
    backButton,
    titleAlign = 'left',
    closeIcon,
    closeButtonDisabled,
    ...other
}) => (
    <MUIDialogTitle
        sx={{
            m: 0,
            pb: 3,
            alignItems: 'center',
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            ...sx,
        }}
        {...other}
    >
        {backButton}
        <Box
            style={{
                flexGrow: 1,
                textAlign: titleAlign,
            }}
        >
            {children}
        </Box>
        {onClose ? (
            <IconButton
                aria-label="close"
                onClick={onClose}
                size="small"
                disabled={closeButtonDisabled}
            >
                {closeIcon ?? <Iconify icon="eva:close-fill" width={20} height={20} />}
            </IconButton>
        ) : null}
    </MUIDialogTitle>
);

export default DialogTitle;
